import { axiosAPI } from '@/plugins/axios';
import { CreateOrUpdateCustomImageField } from '@/modules/customImageField/types';

export const getCustomImageFields = () => axiosAPI.get('/custom-images');
export const getCustomImageFieldById = (id: string) => axiosAPI.get(`/custom-images/${id}`);
export const createCustomImageField = (payload: CreateOrUpdateCustomImageField) => axiosAPI.post('/custom-images', payload);
export const updateCustomImageFieldById = (id: string, payload: CreateOrUpdateCustomImageField) => axiosAPI.put(`/custom-images/${id}`, payload);
export const deleteCustomImageFieldById = (id: string) => axiosAPI.delete(`/custom-images/${id}`);
export const reorderCustomImageFields = (payload: { customImageIds: string[] | undefined }) => axiosAPI.put('/custom-images/order', payload);
